import type { RootState } from "@/store"

const selectEvents = () => (state: RootState) => state.gameplay.events
const selectEventFulfilled = () => (state: RootState) =>
  state.gameplay.isEventFulfilled
const selectSessionId = () => (state: RootState) => state.gameplay.sessionId
const selectPrevState = () => (state: RootState) => state.gameplay.prevState
const selectSocketConnection = () => (state: RootState) =>
  state.gameplay.isSocketConnected
const selectIsMatchActive = () => (state: RootState) =>
  state.gameplay.isMatchActive
const selectIsMatchFinished = () => (state: RootState) =>
  state.gameplay.isMatchFinished
const selectIsMyTurn = () => (state: RootState) => state.gameplay.isMyTurn
const selectIsWinner = () => (state: RootState) => state.gameplay.isWinner
const selectIsTonMatch = () => (state: RootState) => state.gameplay.isTonMatch
const selectLastStateReceivedAt = () => (state: RootState) =>
  state.gameplay.lastStateReceivedAt
const selectIsConnectionOverlayVisible = () => (state: RootState) =>
  state.gameplay.isConnectionOverlayVisible

export const GameplaySelectors = {
  selectEvents,
  selectEventFulfilled,
  selectSessionId,
  selectPrevState,
  selectSocketConnection,
  selectIsMatchActive,
  selectIsMatchFinished,
  selectIsMyTurn,
  selectIsWinner,
  selectIsTonMatch,
  selectLastStateReceivedAt,
  selectIsConnectionOverlayVisible
}
